import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { initDestinationAnimation, setupBottomNav } from '../utils/scripts';
import HeroSection from '../components/home/HeroSection';
import Categories from '../components/home/Categories';
import UpcomingTrips from '../components/home/UpcomingTrips';
import FloatingActionButton from '../components/home/FloatingActionButton';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Testimonials from '../components/testimonials';
import PopUpModal from '../components/PopUpModal'; // Import the PopUpModal component

function Home() {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  
  useEffect(() => {
    // Initialize interactive features
    initDestinationAnimation();
    setupBottomNav();

    // Set timer to show modal after 8 seconds (adjust as needed)
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 8000);

    return () => {
      // Clean up timer when component unmounts
      clearTimeout(timer);
    };
  }, []);

  // Effect to handle scrolling based on hash
  useEffect(() => {
    if (location.hash === '#upcoming-trips') {
      // Use setTimeout to ensure the element is rendered before scrolling
      setTimeout(() => {
        const element = document.getElementById('upcoming-trips');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Adjust delay if needed
    }
  }, [location.hash]); // Re-run effect when hash changes

  return (
    <>
      <Header />
      <HeroSection />
      <Categories />
      <UpcomingTrips /> 
      <FloatingActionButton />
      <Testimonials />
      <Footer />
      
      {/* Popup Modal that shows after delay */}
      <PopUpModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
}

export default Home;